import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'folderName'
})
export class FolderNamePipe implements PipeTransform {

  transform(value: string): string {
    if (value) {
      let transformation = value;
      transformation = value
        .replace(/(\s)/gm, '_')
        .replace(/[^a-zA-Z0-9_]/g, '-')
      return transformation;
    }
    
    return value;
  }

}

@Pipe({
  name: 'fileName'
})
export class FileNamePipe implements PipeTransform {

  transform(value: string): string {
    const maxLen = 20;
    if (value && value.length > maxLen)
      return value.substring(0, maxLen) + '...';
    
    return value;
  }

}